import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import PropTypes from "prop-types";
import { getRehydratableName, getClassNameFactory } from "../../../../utilities";
import { setupClickableCards, cleanupClickableCards } from "../../../../utilities/clickableCardHandler";
import classNames from "classnames";
import contextTypes from "../../contextTypes";

var Panel = /*#__PURE__*/function (_Component) {
  _inherits(Panel, _Component);

  var _super = _createSuper(Panel);

  function Panel() {
    var _this;

    _classCallCheck(this, Panel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "setupClickableCardHandlers", function () {
      // Use setTimeout to give child components time to render
      var RENDER_DELAY = 100;
      var MAX_RETRIES = 5;
      var retries = 0;

      var trySetup = function trySetup() {
        if (_this.containerRef) {
          // Check if there are any clickable cards in the container
          var cards = _this.containerRef.querySelectorAll(".clickable-card[data-href]");

          if (cards.length > 0) {
            // Cards found - setup handlers immediately
            setupClickableCards(_this.containerRef);
          } else if (retries >= MAX_RETRIES) {
            // Max retries reached - setup handlers anyway to ensure initialization
            setupClickableCards(_this.containerRef);
          } else {
            // No cards found yet, retry
            retries++;
            setTimeout(trySetup, RENDER_DELAY);
          }
        }
      };

      setTimeout(trySetup, RENDER_DELAY);
    });

    _defineProperty(_assertThisInitialized(_this), "setContainerRef", function (ref) {
      _this.containerRef = ref;
    });

    return _this;
  }

  _createClass(Panel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add click handlers for clickable-card elements after component mounting
      // This is necessary both for rehydration and for dynamically added content
      this.setupClickableCardHandlers();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Clean up handlers when component unmounts
      if (this.containerRef) {
        cleanupClickableCards(this.containerRef);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          id = _this$props.id,
          tabTitle = _this$props.tabTitle,
          render = _this$props.render;
      var getClassName = getClassNameFactory("TabsPanel");
      var isOpen = this.context.currentOpenPanel === id;
      return /*#__PURE__*/React.createElement("div", {
        "aria-labelledby": "tab-".concat(id),
        role: "tabpanel",
        className: getClassName({
          states: classNames({
            hidden: !isOpen
          })
        }),
        "data-rehydratable": getRehydratableName(Panel.displayName),
        "data-tab-title": tabTitle,
        id: "".concat(id, "-tab"),
        hidden: !isOpen
        /* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */
        ,
        tabIndex: "0",
        ref: this.setContainerRef
      }, /*#__PURE__*/React.createElement("div", {
        "data-rehydratable-children": true
      }, render && render(isOpen), children));
    }
  }]);

  return Panel;
}(Component);

_defineProperty(Panel, "displayName", "Tabs.Panel");

_defineProperty(Panel, "propTypes", {
  /**
   * The contents of this panel.
   */
  render: PropTypes.any,

  /**
   * The contents of this panel.
   */
  children: PropTypes.node,

  /**
   * The id of this panel. Should be unique on the current page.
   */
  id: PropTypes.string.isRequired,

  /**
   * The title of this panel, which will be shown in its associated tab.
   */
  tabTitle: PropTypes.string.isRequired,

  /**
   * The title to display in data-label attribute.
   */
  dataAttribute: PropTypes.string,

  /**
   * Flag indicating if this component is being rehydrated.
   */
  isRehydrating: PropTypes.bool
});

_defineProperty(Panel, "contextTypes", contextTypes);

export default Panel;